import React, { useState, useEffect, useRef } from "react";
import { useHistory } from 'react-router-dom';
import {
  Button, Box, Card, CardContent, Typography, Grid,
  IconButton, FormHelperText
} from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import axios from 'axios';
import swal from 'sweetalert';

const ConferenceEventCertificate = () => {
  const history = useHistory();
  const eventid = localStorage.getItem('eventid');
  const [disabled, setDisabled] = useState(false);
  const [conferenceCerticicateImage, setConferenceCerticicateImage] = useState("");
  const [eventOptionsSetup, setEventOptionsSetup] = useState({
    conference_certificate: "",
    error_list: [],
  });
  const [abstractHomeSetup, setAbstractHomeSetup] = useState({
    color_code_two: "#145348",
  });

  const fileInputRef = useRef(null);

  useEffect(() => {
    axios.get(`api/index-option-setup?id=${eventid}`).then(res => {
      if (res.status === 200) {
        setEventOptionsSetup(res.data.getOptions);
      }
    });

    axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
      if (res.status === 200) {
        setAbstractHomeSetup(res.data.HomePageSetup);
      }
    });
  }, [eventid]);

  const handleCertificateChange = (e) => {
    setConferenceCerticicateImage(e.target.files[0]);
  };

  const optionSubmit = (e) => {
    e.preventDefault();
    const data = {
      eventid,
      conferenceCerticicateImage,
    };

    setDisabled(true);

    axios.get('/sanctum/csrf-cookie').then(() => {
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      };
      axios.post(`/api/add-option-setup`, data, config).then(res => {
        if (res.data.status === 200) {
          swal('Success', res.data.message, 'success');
          axios.get(`api/index-option-setup?id=${eventid}`).then(res => {
            if (res.status === 200) {
              setEventOptionsSetup(res.data.getOptions);
            }
          });
          setDisabled(false);
          setConferenceCerticicateImage("");
          if (fileInputRef.current) fileInputRef.current.value = "";
        } else {
          setEventOptionsSetup({ ...eventOptionsSetup, error_list: res.data.validate_error });
        }
      });
    });
  };

  const backGroundColor = abstractHomeSetup.color_code_two || '#145348';

  return (
    <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>

    <Box sx={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '100vh',
    backgroundColor: '#f9f9f9',
    px: 2,
    pt: 6,
  }}
>
      <Card  sx={{
      width: '100%',
      maxWidth: '900px',
      p: 3,
      boxShadow: 3,
      backgroundColor: 'white',
    }}>
        <Button
          variant="contained"
          onClick={() => history.goBack()}
          sx={{
            position: 'absolute',
            top: 16,
            right: 16,
            backgroundColor: backGroundColor,
            ":hover": { color: 'white' }
          }}
        >
          Back
        </Button>

        <CardContent>
          <Typography variant="h5" gutterBottom>
            Conference Event Certificate
          </Typography>

          <Box component="form" onSubmit={optionSubmit} noValidate sx={{ mt: 3 }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <input
                  accept="image/*"
                  style={{ display: 'none' }}
                  id="certificate-upload"
                  type="file"
                  onChange={handleCertificateChange}
                  ref={fileInputRef}
                />
                <label htmlFor="certificate-upload">
                  <Button
                    variant="outlined"
                    component="span"
                    startIcon={<PhotoCamera />}
                    sx={{ mr: 2 }}
                  >
                    Upload Conference Certificate
                  </Button>
                </label>
                <FormHelperText>
                  {eventOptionsSetup.error_list?.conference_certificate &&
                    `${eventOptionsSetup.error_list?.conference_certificate} width=1920, height=1160`}
                </FormHelperText>
              </Grid>

              {eventOptionsSetup?.conference_certificate &&
                eventOptionsSetup.conference_certificate !== "no_image.jpg" && (
                  <Grid item xs={12}>
                    <img
                      src={eventOptionsSetup.conference_certificate}
                      alt="Certificate Preview"
                      style={{
                        width: '100%',
                        maxWidth: '100%',
                        height: 'auto',
                        borderRadius: '8px',
                        border: '1px solid #ccc'
                      }}
                    />
                  </Grid>
                )}

              <Grid item xs={12} textAlign="right">
                <Button
                  type="submit"
                  variant="contained"
                  disabled={disabled}
                  sx={{ backgroundColor: backGroundColor }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </Box>
    </div>
  );
};

export default ConferenceEventCertificate;
